import { useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import styles from "./ModalPaypal.module.css";
import { useParams } from "react-router-dom";



const ModalPaypal = ({urlpaypal, estado }:any) => {

  const verificaIframe = ()=>{
    const iframe = document.getElementById('frame');
    // const doc = iframe.contentDocument!;

    // doc.



  }

  useEffect(() => {
    
  }, []);


    return(
        <Container>
            <Modal show={estado} centered fullscreen={true}>
              {/* <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header> */}
              <Modal.Body >
                  <iframe id="frame" src={urlpaypal} onChange={verificaIframe} className={styles["iframe"] }></iframe>
            </Modal.Body>
            </Modal> 
        </Container>
    );
}


export default ModalPaypal;